import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownSection() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 49
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        } else {
          return {
            hours: 23,
            minutes: 59,
            seconds: 59
          };
        }
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <section className="py-6 md:py-16 px-4 bg-cf-red text-white text-center" data-id="element-145">
      <div className="max-w-3xl mx-auto" data-id="element-146">
        <div className="flex items-center justify-center gap-2 md:gap-3 mb-3 md:mb-6" data-id="element-147">
          <Clock className="w-4 h-4 md:w-8 md:h-8 animate-pulse shrink-0" data-id="element-148" />
          <h2 className="font-bebas text-base md:text-5xl tracking-wide leading-tight" data-id="element-149">
            EL PRECIO DE LANZAMIENTO TERMINA EN:
          </h2>
        </div>

        <div className="flex justify-center items-start gap-1.5 md:gap-8 mb-3 md:mb-8" data-id="element-150">
          <div className="flex flex-col items-center" data-id="element-151">
            <div className="bg-black/20 rounded-lg px-3 py-2 md:p-4 min-w-[58px] md:min-w-[100px]" data-id="element-152">
              <span className="font-bebas text-3xl md:text-7xl leading-none" data-id="element-153">
                {formatNumber(timeLeft.hours)}
              </span>
            </div>
            <span className="text-[10px] md:text-sm font-bold mt-1 md:mt-2 uppercase tracking-widest" data-id="element-154">
              Horas
            </span>
          </div>
          <div className="text-2xl md:text-6xl font-bebas mt-1.5 md:mt-4 opacity-50 leading-none" data-id="element-155">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-156">
            <div className="bg-black/20 rounded-lg px-3 py-2 md:p-4 min-w-[58px] md:min-w-[100px]" data-id="element-157">
              <span className="font-bebas text-3xl md:text-7xl leading-none" data-id="element-158">
                {formatNumber(timeLeft.minutes)}
              </span>
            </div>
            <span className="text-[10px] md:text-sm font-bold mt-1 md:mt-2 uppercase tracking-widest" data-id="element-159">
              Min
            </span>
          </div>
          <div className="text-2xl md:text-6xl font-bebas mt-1.5 md:mt-4 opacity-50 leading-none" data-id="element-160">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-161">
            <div className="bg-black/20 rounded-lg px-3 py-2 md:p-4 min-w-[58px] md:min-w-[100px]" data-id="element-162">
              <span className="font-bebas text-3xl md:text-7xl leading-none" data-id="element-163">
                {formatNumber(timeLeft.seconds)}
              </span>
            </div>
            <span className="text-[10px] md:text-sm font-bold mt-1 md:mt-2 uppercase tracking-widest" data-id="element-164">
              Seg
            </span>
          </div>
        </div>

        <p className="text-xs md:text-2xl font-bold mb-3 md:mb-8 leading-snug px-2" data-id="element-165">
          Después sube $8.000 ARS y no vuelve a bajar.
        </p>

        <div className="bg-black/20 px-3 py-2.5 md:p-6 rounded-lg md:rounded-xl max-w-md mx-auto" data-id="element-166">
          <div className="flex justify-between text-[10px] md:text-sm font-bold mb-1.5 md:mb-2 gap-2" data-id="element-167">
            <span data-id="element-168">Cupos al precio de lanzamiento</span>
            <span className="shrink-0" data-id="element-169">68% tomados</span>
          </div>
          <div className="w-full bg-black/30 rounded-full h-2 md:h-4 overflow-hidden" data-id="element-170">
            <div className="bg-cf-gold h-full rounded-full" style={{
            width: '68%'
          }} data-id="element-171" />
          </div>
        </div>
      </div>
    </section>;
}